import { formatPrice } from "./common";

const BILLING_FREQUENCY_LABELS = {
  weekly: "weekly",
  biweekly: "every 2 weeks",
  monthly: "monthly",
  bimonthly: "every 2 months",
  quarterly: "quarterly",
  annual: "annually",
  biennial: "every 2 years",
};

export const getBillingFrequencyLabel = (billingFrequency) => {
  if (!billingFrequency) {
    return "";
  }

  return BILLING_FREQUENCY_LABELS[billingFrequency] || billingFrequency;
};

export const formatCurrencyAmount = (currencySign, amount) => {
  return `${currencySign || ""}${formatPrice(amount)}`;
};

export const getInstallmentBreakdown = (packageDetails) => {
  if (packageDetails?.payment_type !== "installment") {
    return null;
  }

  const totalPayments = Number(packageDetails?.number_of_rebills) || 0;
  const futurePayments = Math.max(totalPayments - 1, 0);
  const installmentAmount = formatCurrencyAmount(
    packageDetails?.currency_sign,
    packageDetails?.per_installment_amount
  );
  const billingFrequencyLabel = getBillingFrequencyLabel(
    packageDetails?.billing_frequency
  );

  if (!totalPayments) {
    return null;
  }

  let summary = `${totalPayments} payments of ${installmentAmount} - ${installmentAmount} due today`;

  if (futurePayments > 0 && billingFrequencyLabel) {
    summary += `, then ${futurePayments} ${billingFrequencyLabel} payment${futurePayments === 1 ? "" : "s"}.`;
  } else {
    summary += ".";
  }

  return {
    summary,
    totalPayments,
    futurePayments,
    installmentAmount,
    billingFrequencyLabel,
  };
};

export const buildPackageReturnUrl = ({
  baseUrl,
  packageId,
  inviteId,
  clientId,
}) => {
  const url = new URL(baseUrl);

  if (packageId) {
    url.searchParams.set("package", packageId);
  }

  if (inviteId) {
    url.searchParams.set("invite", inviteId);
  }

  if (clientId) {
    url.searchParams.set("client", clientId);
  }

  return url.toString();
};

export const packageMatchesReference = (packageItem, references = []) => {
  if (!packageItem) {
    return false;
  }

  const normalizedReferences = references
    .filter((value) => value !== null && typeof value !== "undefined" && value !== "")
    .map((value) => String(value));

  if (!normalizedReferences.length) {
    return false;
  }

  const candidates = [
    packageItem?.id,
    packageItem?.package_id,
    packageItem?.packageId,
    packageItem?.package_invite_id,
    packageItem?.packageInviteId,
    packageItem?.invitation_id,
    packageItem?.package_details_id,
    packageItem?.packageDetailsId,
    packageItem?.package?.id,
    packageItem?.package?.package_invite_id,
  ]
    .filter((value) => value !== null && typeof value !== "undefined" && value !== "")
    .map((value) => String(value));

  return candidates.some((candidate) => normalizedReferences.includes(candidate));
};
